import {
  emptyDetalhesServico,
  inferClassificacaoFromLegacy,
  mergeDetalhesFromPrestador,
} from '../constants/prestadorClassificacao';

export const SETORES_PRESTADOR = [
  'Diretoria Técnica',
  'Diretoria Executiva',
  'Gerência Operacional',
  'Coordenação de Enfermagem',
  'Financeiro',
  'Gestão de Gente',
  'Supervisão Administrativa',
  'Manutenção',
  'TI',
  'SCIH',
  'Nutrição',
  'Farmácia',
  'Comunicação',
  'Qualidade',
  'Jurídico',
];

export function formatCNPJ(value) {
  const numbers = String(value || '').replace(/\D/g, '').slice(0, 14);
  if (numbers.length <= 2) return numbers;
  if (numbers.length <= 5) return `${numbers.slice(0, 2)}.${numbers.slice(2)}`;
  if (numbers.length <= 8) return `${numbers.slice(0, 2)}.${numbers.slice(2, 5)}.${numbers.slice(5)}`;
  if (numbers.length <= 12) {
    return `${numbers.slice(0, 2)}.${numbers.slice(2, 5)}.${numbers.slice(5, 8)}/${numbers.slice(8)}`;
  }
  return `${numbers.slice(0, 2)}.${numbers.slice(2, 5)}.${numbers.slice(5, 8)}/${numbers.slice(8, 12)}-${numbers.slice(12)}`;
}

export function cleanCurrency(value) {
  if (!value) return '';
  return String(value).replace(/[^\d,.-]/g, '').replace(',', '.');
}

export function convertDateToISO(dateStr) {
  if (!dateStr) return '';
  const s = String(dateStr).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const parts = s.split('/');
  if (parts.length === 3) {
    const [day, month, year] = parts;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }
  return s;
}

export function convertDateToBrazilian(dateStr) {
  if (!dateStr) return '';
  const s = String(dateStr).trim();
  if (/^\d{2}\/\d{2}\/\d{4}/.test(s)) return s.slice(0, 10);
  const parts = s.split('-');
  if (parts.length === 3) {
    const [year, month, day] = parts;
    return `${day}/${month}/${year}`;
  }
  return s;
}

export function parseEmpresaEspecialidade(empresa) {
  const m = String(empresa || '').match(/^(.+?)\s*\(\s*([^)]+)\s*\)\s*$/);
  if (m) {
    return { base: m[1].trim(), especialidade: m[2].trim() };
  }
  return { base: String(empresa || '').trim(), especialidade: '' };
}

export function buildEmpresaExibicao(form) {
  return String(form.empresa || '').trim();
}

export function toBool(v) {
  return v === 1 || v === true || v === '1' || v === 'true';
}

export function isEmailPlaceholderPortal(email) {
  return /^pendente\.\d{11,14}@portal\.sgc\.local$/i.test(String(email || '').trim());
}

export function prestadorToWizardForm(prestador, portal = {}) {
  const { base, especialidade: espNome } = parseEmpresaEspecialidade(prestador?.empresa);
  const emailPortal =
    portal.email && !isEmailPlaceholderPortal(portal.email) ? portal.email : '';
  const { tipoContrato, categoriaServico } = inferClassificacaoFromLegacy(prestador || {});
  const detalhes = mergeDetalhesFromPrestador(prestador || {});
  if ((!detalhes.especialidades || !detalhes.especialidades.length) && espNome) {
    detalhes.especialidades = [espNome];
  }
  return {
    empresa: base,
    cnpj: formatCNPJ(prestador?.cnpj || ''),
    email: emailPortal,
    telefone: portal.telefone || '',
    numeroContrato: prestador?.numeroContrato || '',
    assinatura: convertDateToISO(prestador?.assinatura),
    vigenciaInicio: convertDateToISO(prestador?.vigenciaInicio),
    vigenciaFim: convertDateToISO(prestador?.vigenciaFim),
    valorMes: prestador?.valorMes || '',
    setor: prestador?.setor || '',
    objeto: prestador?.objeto || '',
    eventual: toBool(prestador?.eventual),
    corporativo: toBool(prestador?.corporativo),
    tipoContrato,
    categoriaServico,
    detalhesServico: { ...emptyDetalhesServico(), ...detalhes },
    periodicidade:
      prestador?.periodicidade ||
      (toBool(prestador?.eventual) ? 'eventual_avulso' : 'mensal'),
    regimeValor: prestador?.regimeValor || 'valor_fixo',
    numeroParcelas: prestador?.numeroParcelas || prestador?.parcelas || 12,
    valorPorParcela: prestador?.valorPorParcela || '',
    parcelas: prestador?.parcelas || 12,
    criarLoginPortal: true,
    senhaPortal: '',
  };
}
